import { assign, Machine } from "xstate";
import { helperActions, getGraphQlData } from "@/utils/machine-helpers";
import { apolloClient } from "@/lib/apollo/apollo";
import { FeatureCheck } from "@/graphql/queries";

export default Machine(
  {
    id: "featureCheck",

    initial: "loading",

    context: {
      errors: [],
      feature: "",
      requiredPackage: null,
    },

    states: {
      loading: {
        invoke: {
          id: "featureCheck",
          src: "featureCheckQuery",
          onDone: [
            {
              target: "upgradeRequired",
              cond: "isUpgradeRequired",
              actions: "assignRequiredPackage",
            },
            {
              target: "upgradeNotRequired",
            },
          ],
          onError: {
            target: "error",
            actions: "assignErrors",
          },
        },
      },
      upgradeRequired: {
        type: "final",
      },
      upgradeNotRequired: {
        type: "final",
      },
      error: {
        on: {
          RETRY: "loading",
        },
      },
    },
  },
  {
    actions: {
      ...helperActions,
      assignRequiredPackage: assign({
        requiredPackage: (context, event) => {
          return getGraphQlData(event, "featureCheck.requiredPackage");
        },
      }),
    },
    guards: {
      isUpgradeRequired: (context, event) => {
        return event.data?.data?.featureCheck?.upgradeRequired;
      },
    },
    services: {
      featureCheckQuery: (context, event) => featureCheckQuery(context.feature),
    },
  }
);

const featureCheckQuery = (feature) => {
  const variables = {
    input: {
      feature,
    },
  };

  return apolloClient.query({
    query: FeatureCheck,
    variables,
  });
};
